import moment from "moment";

// Feriados nacionais fixos (formato MM-DD)
const FIXED_HOLIDAYS = [
  "01-01", // Confraternização Universal
  "04-21", // Tiradentes
  "05-01", // Dia do Trabalho
  "09-07", // Independência
  "10-12", // Nossa Senhora Aparecida
  "11-02", // Finados
  "11-15", // Proclamação da República
  "11-20", // Consciência Negra
  "12-25", // Natal
];

// Domingo de Páscoa pelo algoritmo de Meeus/Jones/Butcher
function easterSunday(year: number): moment.Moment {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=março, 4=abril
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return moment({ year, month: month - 1, day });
}

const movableCache = new Map<number, Set<string>>();

// Feriados móveis: Carnaval (seg/ter), Sexta-feira Santa e Corpus Christi
function movableHolidays(year: number): Set<string> {
  const cached = movableCache.get(year);
  if (cached) return cached;

  const easter = easterSunday(year);
  const set = new Set<string>([
    easter.clone().subtract(48, "days").format("MM-DD"), // Segunda de Carnaval
    easter.clone().subtract(47, "days").format("MM-DD"), // Terça de Carnaval
    easter.clone().subtract(2, "days").format("MM-DD"),  // Sexta-feira Santa
    easter.clone().add(60, "days").format("MM-DD"),      // Corpus Christi
  ]);
  movableCache.set(year, set);
  return set;
}

export function isBusinessDay(date: moment.Moment): boolean {
  const dow = date.day();
  if (dow === 0 || dow === 6) return false;
  const mmdd = date.format("MM-DD");
  if (FIXED_HOLIDAYS.includes(mmdd)) return false;
  return !movableHolidays(date.year()).has(mmdd);
}

// Avança `days` dias úteis a partir de `date` (não modifica o original)
export function addBusinessDays(
  date: moment.Moment | string,
  days: number
): moment.Moment {
  const result = moment(date).startOf("day");
  let remaining = days;
  while (remaining > 0) {
    result.add(1, "day");
    if (isBusinessDay(result)) remaining--;
  }
  return result;
}
